module.exports = __webpack_public_path__ + "7ff3dfab730113840ee18f06d5a465e1.MP3";